import React, { useRef, useEffect } from 'react';

const RadioButtonGroup = ({ buttons, ...rest }) => {
  const radioGroupRef = useRef(null);

  useEffect(() => {
    // Set buttons property via setAttribute if it's an array/object
    if (radioGroupRef.current && buttons !== undefined) {
      if (typeof buttons === 'string') {
        radioGroupRef.current.setAttribute('buttons', buttons);
      } else {
        // Convert array/object to JSON string
        radioGroupRef.current.setAttribute('buttons', JSON.stringify(buttons));
      }
    }
  }, [buttons]);

  return (
    <nsemble-radio-group
      ref={radioGroupRef}
      {...rest}
    />
  );
};

export default RadioButtonGroup;
